module.exports = __webpack_public_path__ + "static/media/team_img.ebedaecc.png";